import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { CircleIcon } from "./svgIcons";
import { Helmet } from "react-helmet";

const usePageTitle = () => {
  const location = useLocation();

  const pageTitle = location.pathname
    .split("/")
    .filter(Boolean)
    .pop() || "Dashboard";

  const formattedTitle = pageTitle
    .replace(/-/g, " ") // Replace hyphens with spaces
    .replace(/(lead)s?/, " Lead") // Ensure space before "Lead"
    .replace(/^(\w+)/, (match) => match.charAt(0).toUpperCase() + match.slice(1)) // Capitalize first word
    .replace(/\bLead\b/g, "Leads") // Ensure "Lead" stays capitalized
    .replace(/\bLeads\b/g, "Leads"); // Ensure "Leads" stays capitalized

  useEffect(() => {
    document.title = formattedTitle;
  }, [formattedTitle]);

  return (
    <>
      <Helmet>
        <title>{formattedTitle} | EV-INDIA</title>
      </Helmet>
      <div className="page-heading flex justify-between gap-3 items-center !p-[0.45rem] !px-6 rounded-3xl bg-white border border-gray-100">
        <div><h1 className="text-[16px] font-semibold">{formattedTitle === 'All' ? 'All Leads' : formattedTitle}</h1></div>
        <div className="flex flex-row items-center gap-2">
          <NavLink to="/dashboard" className="text-[14px]" >Dashboard</NavLink>
          <CircleIcon />
          <p className="text-[14px]">{formattedTitle}</p>
        </div>
      </div>
    </>

  ); // Return the formatted title
};

export default usePageTitle;
